export default "__VITE_ASSET__DwGILMca__"